import { DotLegalTextField } from "@dotlegal/dotlegal-ui-components";
import React from "react";
import { isNullOrWhitespace, setFirstLetterToLowerCase } from "../../../common/stringOperations.ts";
import { InputFieldTypeEnum } from "../../inputFields/InputFields.types.ts";
import { useTranslation } from "../../../localization/useTranslation.ts";
import { useCustomField } from "./customField.hooks.ts";

export interface CustomTextFieldProps {
    /** Lets a caller that owns the vertical rhythm itself turn the field's own margin off. */
    noMargin?: boolean;
    /** Puts the label above the input with the help icon beside it, for a form laid out that way. */
    useFixedLabel?: boolean;
    isLoading: boolean;
    entityId: string;
    entityApiPath: string;
    customInputFieldId: string;
    fieldName: string;
    fieldDescription: string | undefined;
    value: string;
    onChange: (changeFunc: (entity: any) => void) => void;
    readOnly?: boolean;
    isDisabled: boolean;
    errorText?: string;
    isPreview: boolean;
}

function CustomTextField(props: CustomTextFieldProps) {
    const { translateString } = useTranslation();

    const { onFieldChange } = useCustomField(props.entityApiPath, props.entityId, props.customInputFieldId, props.onChange);
    return (
        <DotLegalTextField
            noMargin={props.noMargin}
            useFixedLabel={props.useFixedLabel}
            isLoading={props.isLoading}
            label={props.fieldName}
            toolTipText={props.fieldDescription}
            value={props.value}
            debounce
            onChange={props.readOnly ? () => {} : (value) => onFieldChange(value)}
            disabled={props.isDisabled}
            errorText={!isNullOrWhitespace(props.errorText) && !props.isPreview ? props.errorText : undefined}
            helperText={props.isPreview ? translateString(setFirstLetterToLowerCase(InputFieldTypeEnum[InputFieldTypeEnum.TextField].toString())) : undefined}
        />
    );
}

export default CustomTextField;
